import api from '../api/api-list'

const state = {
	specialOfferList:[],   // 优惠券列表
	specialOffer:{},     // 当前优惠券
}

const actions = {
	// 获取相关优惠券
	getSpecialOfferData: async function ({ commit, state},{cv_account_token, data}) {
		let res = await api.user.getAccountSpecialOffers(cv_account_token, data)
		if (res.code === 1000) {
			let couponList = res.data.coupons.filter(item => item.usable === true)
			commit('setSpecialOfferData', couponList)
		}
	}
}

const mutations = {
	// 更新优惠券列表
	setSpecialOfferData (state, list) {
		state.specialOfferList = list
		if (list.length > 0) {
			state.specialOffer = list[0]
		}
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
